<script setup lang="ts">
  import type { SectionLine } from '@/stores/type/sectionLine.type'
  import type { PropType } from 'vue'
  import { useEventsBus } from '@haskoning/vue-component-library'
  import useProfilePermissions from '@/composables/useProfilePermission'
  import { useGIPointsStore } from '@/stores/giPoints'

  const emit = defineEmits(['remove-gi-point-selection', 'cancel-selection', 'delete'])
  const props = defineProps({
    item: { type: Object as PropType<SectionLine>, required: true }
  })
  const sectionLinesStore = useSectionLinesStore()
  const selectionPolygonsStore = useSelectionPolygonsStores()
  const giPointsStore = useGIPointsStore()
  const { giPointsBySectionLineId, showSelectMap } = storeToRefs(sectionLinesStore)
  const { polygonsBySectionLineId } = storeToRefs(selectionPolygonsStore)
  const { emit: busEmit } = useEventsBus()
  const { canEditSectionLine } = useProfilePermissions()

  const emitItem = (item: SectionLine) => {
    busEmit('fly-to-polyline', item)
  }
</script>

<template>
  <v-list-item-title
    class="d-flex justify-space-between align-center w-100 pl-2"
    @click="sectionLinesStore.setCurrentItem(props.item)"
  >
    <div class="d-flex justify-space-between align-center w-100">
      <v-row no-gutters>
        <v-col cols="4" class="d-inline-block text-truncate align-center d-flex">
          <div class="d-flex align-center g-1">
            <v-checkbox
              color="primary"
              density="compact"
              hide-details
              :model-value="sectionLinesStore.isSelected(props.item.id)"
              @update:model-value="
                sectionLinesStore.toggleSelectedSectionLine(
                  props.item,
                  !sectionLinesStore.isSelected(props.item.id)
                )
              "
              @click.stop=""
            ></v-checkbox>
            <span
              style="color: black"
              class="d-block text-truncate text-primary ml-2"
              @click.stop.prevent="emitItem(props.item)"
            >
              {{ props.item.properties.section_title }}
              {{ props.item.properties.section_code && `(${props.item.properties.section_code})` }}
            </span>
          </div>
        </v-col>
        <v-col cols="3" class="d-inline-block align-center">
          <div class="d-flex align-center justify-center h-100">
            <span>GI Points</span>
            <v-chip
              label
              class="ml-2"
              density="comfortable"
              @click.stop="
                giPointsStore.toggleSelectedGIPoints(giPointsBySectionLineId(props.item.id))
              "
            >
              <span class="text-primary"> {{ giPointsBySectionLineId(props.item.id).length }}</span>
            </v-chip>
          </div>
        </v-col>

        <v-col cols="4">
          <div class="d-flex align-center justify-center h-100">
            <span>Selection Polygons</span>
            <v-chip
              label
              class="ml-2"
              density="comfortable"
              @click.stop="
                selectionPolygonsStore.toggleSelectedPolygons(
                  selectionPolygonsStore.polygonsBySectionLineId(props.item.id)
                )
              "
            >
              <span class="text-primary"> {{ polygonsBySectionLineId(props.item.id).length }}</span>
            </v-chip>
          </div>
        </v-col>
        <v-col
          cols="1"
          @click.stop="
            sectionLinesStore.setCurrentItem(props.item),
              sectionLinesStore.toggleUpdateSectionLineDialog('edit')
          "
        >
          <div v-if="canEditSectionLine" class="d-flex justify-end align-center h-100">
            <v-icon class="text-primary"> mdi-pencil</v-icon>
          </div>
        </v-col>
      </v-row>
    </div>

    <div
      v-if="showSelectMap[props.item.id] === 'remove'"
      class="d-flex justify-center align-center ml-auto"
    >
      <v-btn
        class="ml-3"
        color="primary"
        size="x-small"
        variant="flat"
        @click.stop="emit('remove-gi-point-selection')"
      >
        Remove
      </v-btn>
      <v-btn
        class="ml-1"
        color="error"
        size="x-small"
        variant="outlined"
        @click.stop="emit('cancel-selection')"
      >
        Cancel
      </v-btn>
    </div>
  </v-list-item-title>
</template>
<style scoped></style>
